//CalendarUtils.js
export const getEventClass = (eventType) => {
  switch (eventType) {
    case 'Rapor':
      return 'bg-info-subtle text-info';
    case 'Bakım':
      return 'bg-success-subtle text-success';
    case 'Onarım':
      return 'bg-warning-subtle text-warning';
    case 'Teklif':
      return 'bg-primary-subtle text-primary';
    case 'Hatırlatma':
      return 'bg-secondary-subtle text-secondary';
    case 'Proje Başlangıcı':
      return 'bg-indigo-subtle text-indigo';
    case 'Proje Bitişi':
      return 'bg-purple-subtle text-purple';
    case 'Fatura':
      return 'bg-danger-subtle text-danger';
    case 'Tedarikçi':
      return 'bg-dark-subtle text-dark';
    case 'Teknik Servis':
      return 'bg-teal-subtle text-teal';
    default:
      return 'bg-light-subtle text-primary';
  }
};
